package pl.decks.chartjs.silk.radar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.Canvas
import org.w3c.dom.HTMLCanvasElement
import pl.decks.chartjs.radar.Radar
import pl.decks.chartjs.radar.RadarConfig

@Composable
fun RadarChart(
    canvasId: String,
    config: RadarConfig,
    modifier: Modifier = Modifier,
) {
    val chartRef = remember { mutableStateOf<Radar?>(null) }

    Canvas(
        attrs = modifier.toAttrs {
            id(canvasId)
        }
    )

    DisposableEffect(canvasId) {
        val canvas = document.getElementById(canvasId) as HTMLCanvasElement
        chartRef.value = Radar(canvas, config)

        onDispose {
            chartRef.value?.destroy()
            chartRef.value = null
        }
    }

    LaunchedEffect(config) {
        chartRef.value?.updateConfig(config)
    }
}
